module.exports = __webpack_public_path__ + "img/userIcon.b9a2fed3.png";